import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SbWrapperComponent } from './sb-wrapper.component';
import { SbBadgeModule } from '../sb-badge/sb-badge.module';
import { GasScrollModule } from '@cikrf/gas-ui-kit';

const COMPONENTS = [
  SbWrapperComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    SbBadgeModule,
    GasScrollModule,
  ],
})
export class SbWrapperModule { }
